import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'bootstrap';

import React from 'react';
window.React = React;

import ReactDOM from 'react-dom';
window.ReactDOM = ReactDOM;

import SubjectSlat from './components/SubjectSlat';
window.SubjectSlat = SubjectSlat;

import AssetSlat from './components/AssetSlat';
window.AssetSlat = AssetSlat;

import PlaylistSlat from './components/PlaylistSlat';
window.PlaylistSlat = PlaylistSlat;

import AssetList from './components/AssetList';
window.AssetList = AssetList;

import AssignedAssetList from './components/AssignedAssetList';
window.AssignedAssetList = AssignedAssetList;

import Assignments from './components/Assignments';
window.Assignments = Assignments;

import LoginDialog from './components/LoginDialog';
window.LoginDialog = LoginDialog;

import ShareDialog from './components/ShareDialog';
window.ShareDialog = ShareDialog;

import ShortcodeDialog from './components/ShortcodeDialog';
window.ShortcodeDialog = ShortcodeDialog;

import AssetDetails from './components/AssetDetails';
window.AssetDetails = AssetDetails;

import Breadcrumbs from './components/Breadcrumbs';
window.Breadcrumbs = Breadcrumbs;

import HeaderNav from './components/HeaderNav';
window.HeaderNav = HeaderNav;

import FooterNav from './components/FooterNav';
window.FooterNav = FooterNav;

import '../css/site.scss';